import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { catchError, map, mergeMap, of, pipe, switchMap, tap, withLatestFrom } from "rxjs";
import { CoreSelectors } from "../../core";
import { SharedActions } from ".";
import { SharedApiService } from "../../../services/shared-api.service";

@Injectable({ providedIn: 'root' })
export class SharedEffects {

    constructor(
        public store: Store,
        private actions$: Actions,
        private sharedApiService: SharedApiService
    ) { }

    private appendTimestamp<T>(
        accessor: (obj: Record<string, T>) => T,
    ) {
        return pipe(
            map(accessor),
            withLatestFrom(this.store.select(CoreSelectors.getCurrentUser)),
            map(([entity, currentUser]) => ({
                ...entity,
                lastSavedOn: new Date(),
                lastSavedById: currentUser.id
            }))
        )
    }

    LoadTags$ = createEffect(() => this.actions$.pipe(
        ofType(SharedActions.LoadTags.initial),
        mergeMap(() => this.sharedApiService.getTags().pipe(
            map((tags) => SharedActions.LoadTags.success({ tags })),
            catchError((error) => of(SharedActions.LoadTags.failure({ error })))
        ))
    ))

}